"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.isSubscribedConditionMet = exports.isSubscribedConditionSet = exports.isAuthenticatedConditionMet = exports.isAuthenticatedConditionSet = exports.isAccessLevelCondition = exports.isPlatformCondition = exports.isPlatformsConditionMet = exports.isPlatformsConditionSet = void 0;
const is_plain_object_1 = __importDefault(require("./is-plain-object"));
// TODO: Drop this module #1649
/**
 * Factory to create boolean isConditionSet utilities.
 */
function createIsBooleanConditionSet(name) {
    return (conditions) => (0, is_plain_object_1.default)(conditions) &&
        name in conditions &&
        typeof conditions[name] === "boolean";
}
/**
 * Factory to create boolean isConditionMet utilities.
 */
function createIsBooleanConditionMet(name) {
    const isSet = createIsBooleanConditionSet(name);
    return (conditions, value) => !isSet(conditions) || conditions[name] === value;
}
/**
 * PLATFORM CONDITION
 */
const isPlatformsConditionSet = (conditions) => (0, is_plain_object_1.default)(conditions) &&
    "platforms" in conditions &&
    Array.isArray(conditions.platforms) &&
    conditions.platforms.every((platform) => typeof platform === "string");
exports.isPlatformsConditionSet = isPlatformsConditionSet;
const isPlatformsConditionMet = (conditions, platform) => !(0, exports.isPlatformsConditionSet)(conditions) ||
    conditions.platforms.includes("all") ||
    (platform !== undefined && conditions.platforms.includes(platform));
exports.isPlatformsConditionMet = isPlatformsConditionMet;
const isPlatformCondition = (platform) => typeof platform === "string" &&
    ["ios", "android", "web", "all"].includes(platform);
exports.isPlatformCondition = isPlatformCondition;
/**
 * ACCESS LEVEL CONDITION
 */
const isAccessLevelCondition = (accessLevel) => typeof accessLevel === "string" &&
    ["paid", "protected", "public"].includes(accessLevel);
exports.isAccessLevelCondition = isAccessLevelCondition;
/**
 * AUTHENTICATED CONDITION
 */
exports.isAuthenticatedConditionSet = createIsBooleanConditionSet("authenticated");
exports.isAuthenticatedConditionMet = createIsBooleanConditionMet("authenticated");
/**
 * SUBSCRIBED WITH PLAN CONDITION
 */
exports.isSubscribedConditionSet = createIsBooleanConditionSet("subscribed");
exports.isSubscribedConditionMet = createIsBooleanConditionMet("subscribed");
